export const getMenuAccessToken = ({ menu }) => menu.get('accessToken')
export const getMenuLimits = ({ menu }) => menu.get('menuLimits')
export const getCuratedBoxName = ({ state }) => state.menu.get('curatedBoxName', '')
